import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import PageShell from "@/components/founding/PageShell";
import { apiBase } from "@/lib/apiBase";
import { UNSUBSCRIBE_COPY } from "@/constants/waitlistCopy";

const API = apiBase();

export default function WaitlistUnsubscribePage() {
    const [params] = useSearchParams();
    const token = params.get("token") || "";
    const [state, setState] = useState(token ? "confirm" : "invalid");

    const confirm = () => {
        if (!token || state === "working") return;
        setState("working");
        axios.post(`${API}/waitlist/unsubscribe`, { token })
            .then(() => setState("done"))
            .catch(() => setState("invalid"));
    };

    return (
        <PageShell>
            <section className="bg-black py-20 text-white min-h-[50vh]">
                <div className="mx-auto max-w-xl px-6">
                    {state === "confirm" ? (
                        <>
                            <p data-testid="unsubscribe-prompt">{UNSUBSCRIBE_COPY.prompt}</p>
                            <button
                                type="button"
                                className="mt-6 border border-red-500 px-6 py-3 font-bold text-red-500"
                                data-testid="unsubscribe-confirm"
                                onClick={confirm}
                            >
                                {UNSUBSCRIBE_COPY.confirm}
                            </button>
                        </>
                    ) : null}
                    {state === "done" ? (
                        <>
                            <h1
                                className="text-3xl font-bold"
                                data-testid="unsubscribe-title"
                            >
                                {UNSUBSCRIBE_COPY.title}
                            </h1>
                            <p className="mt-4 text-slate-300" data-testid="unsubscribe-body">
                                {UNSUBSCRIBE_COPY.body}
                            </p>
                        </>
                    ) : null}
                    {state === "invalid" ? (
                        <h1
                            className="text-3xl font-bold"
                            data-testid="unsubscribe-invalid"
                        >
                            {UNSUBSCRIBE_COPY.invalid}
                        </h1>
                    ) : null}
                    {state === "working" ? (
                        <p data-testid="unsubscribe-working">{UNSUBSCRIBE_COPY.working}</p>
                    ) : null}
                </div>
            </section>
        </PageShell>
    );
}
